
import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import separator from "assets/img/Separator.png";
import { BannerBox } from "utils/DynamicComponents/LandingComponents";
import { Dynamic_Style } from "./Dynamic_Style";
import { BannerTitle } from "utils/DynamicComponents/LandingComponents";
import { Info } from "@material-ui/icons";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export default function NewQuotes(props) {
    const isMobile = useMediaQuery('(max-width: 1152px)');

    const [data, setData] = useState({});
    const [dataYTD, setDataYTD] = useState({});

    const GetData = async () => {
        setData({});

        const response = await CallAPI("POST", "/Home/GetNewQuotes", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            getQuoteType: true
        });

        if (response)
            setData(response);
    };

    const GetDataYTD = async () => {
        setDataYTD({});

        const today = new Date();
        const response = await CallAPI("POST", "/Home/GetNewQuotes", {
            startDate: 1 + '/' + 1 + '/' + today.getFullYear(),
            endDate: (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear(),
            states: props.states,
            city: props.city,
            getQuoteType: true
        });

        if (response)
            setDataYTD(response);
    };

    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            GetData();
            GetDataYTD();
        }
    }, [props.call]);

    useEffect(() => {
        if (data.total && dataYTD.total) {
            props.onSuccess();
        }
    }, [data, dataYTD]);

    return (
        <div>
            <Grid container spacing={0} style={{ marginTop: "2em", marginLeft: "1em", marginRight: "1em" }}>
                <BannerTitle
                    Header={"QUOTES"}
                    SubHeader={"(BIND %)"}
                    SubHeaderPopover={"Percentage of policies bound to-date, based on the specific quotes from each applicable time period."}
                />
                <Grid container
                    lg={4}
                    xs={11}
                    style={isMobile ? Dynamic_Style.BlueContainer_Mobile : Dynamic_Style.BlueContainer_Desktop}
                >
                    <BannerBox Dotted={true} ColumnSize={3} Heading={"TOTAL"} Data={data.total} Footer={data.totalBindPercentage}/>
                    <BannerBox ColumnSize={3} Heading={"Quick"} Footer={data.quickBindPercentage}>
                        {(data.quick < 0 &&
                            <TooltipButton
                                tooltipText={"Known sync problem with the GW tables, please check back at 09:30 am when fully synced."}
                                icon={<Info />}
                                style={{ color: "palevioletred", position: "relative" }}
                            />
                        ) || data.quick}
                    </BannerBox>
                    <BannerBox ColumnSize={2} Heading={"Custom"} Footer={data.customBindPercentage}>
                        {(data.custom < 0 &&
                            <TooltipButton
                                tooltipText={"Known sync problem with the GW tables, please check back at 09:30 am when fully synced."}
                                icon={<Info />}
                                style={{ color: "palevioletred", position: "relative" }}
                            />
                        ) || data.custom}
                    </BannerBox>
                    <BannerBox ColumnSize={2} Heading={"CRC"} Data={data.crc} Footer={data.crcBindPercentage}/>
                    <BannerBox ColumnSize={2} Heading={"Agency"} Data={data.agency} Footer={data.agencyBindPercentage}/>
                </Grid>
                <Grid container
                    lg={4}
                    xs={11}
                    style={isMobile ? Dynamic_Style.BlueContainer_Mobile : Dynamic_Style.BlueContainer_Desktop}
                >
                     <img src={separator} width="100%" style={isMobile ? Dynamic_Style.SeparatorWithSubHeader_Mobile : Dynamic_Style.SeparatorWithSubHeader_Desktop} alt="..." />
                     <span style={isMobile ? Dynamic_Style.YTDLabelWithSubHeader_Mobile : Dynamic_Style.YTDLabelWithSubHeader_Desktop}>
                         YTD
                     </span>
                    <BannerBox Dotted={true} ColumnSize={3} Heading={"Total"} Data={dataYTD.total}/>
                    <BannerBox ColumnSize={3} Heading={"Quick"}>
                        {(dataYTD.quick < 0 &&
                            <TooltipButton
                                tooltipText={"Known sync problem with the GW tables, please check back at 09:30 am when fully synced."}
                                icon={<Info />}
                                style={{ color: "palevioletred", position: "relative" }}
                            />
                        ) || dataYTD.quick}
                    </BannerBox>
                    <BannerBox ColumnSize={2} Heading={"Custom"}>
                        {(dataYTD.custom < 0 &&
                            <TooltipButton
                                tooltipText={"Known sync problem with the GW tables, please check back at 09:30 am when fully synced."}
                                icon={<Info />}
                                style={{ color: "palevioletred", position: "relative" }}
                            />
                        ) || dataYTD.custom}
                    </BannerBox>
                    <BannerBox ColumnSize={2} Heading={"CRC"} Data={dataYTD.crc}/>
                    <BannerBox ColumnSize={2} Heading={"Agency"} Data={dataYTD.agency}/>
                </Grid>                        
            </Grid>
        </div>
    );
}
